/**
 * 運営の問い合わせ先（#260、ADR-032 A1）。App Review 1.2 が UGC を扱うアプリに連絡先の公開を求めている。
 *
 * Cloudflare の Email Routing で、運営の受信箱に転送する（`docs/guides/deployment.md` の「問い合わせ先のメール」）。
 * **個人のアドレスをここにも画面にも書かない。**
 */
export const SUPPORT_EMAIL = 'support@drawgon.app';
